import { Controller } from "@hotwired/stimulus";
import Viewer from "viewerjs";

export default class extends Controller<HTMLImageElement | HTMLElement> {
  private _imageViewer: Viewer | null = null;

  connect(): void {
    this._initialViewer();
  }

  disconnect() {
    this._imageViewer?.destroy();
  }

  show() {
    if (!this._imageViewer) return;

    this._imageViewer.show();
  }

  private _initialViewer() {
    if (!this._imageViewer) {
      this._imageViewer = new Viewer(this.element, {
        inline: false,
        backdrop: true,
        fullscreen: true,
        toolbar: {
          prev: true,
          next: true,
        },
      });
    }
  }
}
